const CookieConsent = {

    init: function () {
        this.checkCookieConsent();
        $('#cookieConsentSubmit').on('click', this.saveCookieConsent);
        $('#cookieConsentOpener').on('click', () => {
            $('.cookie-consent-container').removeAttr("hidden");
            $('#cookieConsentOpener').attr("hidden", true);
        });
    },

    setConsentCookie: function (type) {
        var d = new Date();
        d.setTime(d.getTime() + (365*24*60*60*1000));  // 365 days
        var expires = "expires="+d.toUTCString();
        document.cookie = "cookieConsentType="+type+";" + expires +";path=/; Secure"
    },

    getConsentCookie: function () {
        var rawCookieValue = document.cookie
          .split("; ")
          .find((row) => row.startsWith("cookieConsentType="));

        return (rawCookieValue) ? rawCookieValue.split("=")[1] : undefined;
    },

    getMarketingEnabled: function () {
        return this.getConsentCookie() === "ALL";
    },

    checkCookieConsent: function () {
        var consentCookie = this.getConsentCookie();
        if (consentCookie === "ALL") {
            $('#cookieMarketingToggle').prop("checked", true);
        }
        if (!consentCookie) {
            $('.cookie-consent-container').removeAttr("hidden");
        } else {
            $('#cookieConsentOpener').removeAttr("hidden");
        }
    },

    saveCookieConsent: function () {
        var cookieType = $('#cookieMarketingToggle').prop("checked") ? "ALL" : "ESSENTIAL";
        document.cookie = "cookieConsentType="+cookieType+";path=/; Secure";
        $('.cookie-consent-container').attr("hidden", true);
        location.reload();
    }
};

